import { CampaignDetailModelState } from '@urbanx/agx.campaigns.client'
import QldAgreementDetails from './QldAgreementDetails'
import NswAgreementDetails from './NswAgreementDetails'
import { BaseComplianceModalProps } from 'pages/allTasks/ComplianceModal/BaseComplianceModalProps'

const AgreementDetails = (props: BaseComplianceModalProps) => {
  const { campaign } = props

  switch (campaign.state) {
    case CampaignDetailModelState.QLD:
      return <QldAgreementDetails {...props} />
    case CampaignDetailModelState.NSW:
      return <NswAgreementDetails {...props} />
    default:
      return null
  }
}

export default AgreementDetails
